module.exports = __webpack_public_path__ + "img/doc.13b593a3.svg";